export enum UserMenuOptions {
  Account = 'Account',
  Subscription = 'Subscription',
  ScanPackage = 'Scan Package',
  Logout = 'Log out',
  TFactor = '2 Factor Authentication',
}
